export function getStandardDeliveryQTYByZoneObject(data, zoneNumber) {
  let deliveryOrders = data.filter(deliveryOrder => {
    return deliveryOrder.zone == zoneNumber;
  });

  return deliveryOrders;
}

export function getStandardCycleDeliveryQTYByZoneObject(data, zoneNumber) {
  let logCount = 0;
  data.filter(deliveryOrder => {
    if (deliveryOrder.zone == zoneNumber) {
      if (deliveryOrder.recycleLogs) {
        let count = deliveryOrder.recycleLogs.filter(log => {
          return log.failedOrReopenInfo === "ARRIVED";
        });
        logCount += count.length;
      }
    }
  });


  return logCount;
}

export function getStandardDeliveryQTYByZone(data, zoneNumber) {
  let deliveryOrders = getStandardDeliveryQTYByZoneObject(data, zoneNumber);

  return deliveryOrders.length;
}

export function getStandardCycleDeliveryQTYByZone(data, zoneNumber) {
  let cycleCount = getStandardCycleDeliveryQTYByZoneObject(data, zoneNumber);
  return cycleCount;
}

export function getAmountInUSD(amount, price) {
  if (amount === Infinity) {
    amount = 0;
  }
  return amount * price;
}

export function getProvinceQTY(data) {
  let provinceDeliveryOrders = data.filter(deliveryOrder => {
    return (
      deliveryOrder.serviceType == "delivered" &&
      deliveryOrder.isProvinceTransfer == true
    );
  });
  return provinceDeliveryOrders.length;
}

export function getTotal(...arr) {
  let total = 0;
  for (var i = arr.length - 1; i >= 0; i--) {
    total += arr[i];
  }

  return total;
}

export const singleOrPlural = (text, number = 0) => {
  return number > 1 ? text + "s" : text;
};

export const numberOfDeliveryFailedArrived = recycleLogs => {
  let count = 0;
  count = recycleLogs.filter(log => {
    return log.failedOrReopenInfo === "ARRIVED";
  });

  return count.length;
};

export const getWareHouseCalculation = (
  size,
  unitPrice,
  unit,
  skuUsed,
  skuPrice
) => {
  if (skuUsed <= unit) {
    return size * unitPrice;
  } else {
    return size * unitPrice + (skuUsed - unit) * skuPrice;
  }
};
